export default __webpack_public_path__ + "static/media/podkrovi-pokoj-mensi.36e6cf0e.jpeg";